import { QueryList } from '@angular/core';
import { LineStylePanel } from 'markerjs2';
import { RadioComponent } from '../../../../../Common/Forms/components/Radio/radio.component';


export class ChartAnnotationLineStylePanel extends LineStylePanel {

    radioGroup: HTMLDivElement;
    currentLineStyle: string;
    radioComponents: QueryList<RadioComponent>;


    constructor(
        title: string,
        styles: string[],
        currentStyle?: string,
        icon?: string,
        radioGroup?: HTMLDivElement,
        radioComponents?: QueryList<RadioComponent>
    ) {
        super(
            title,
            styles,
            currentStyle,
            icon
        );
        this.radioGroup = radioGroup;
        this.currentLineStyle = currentStyle;
        this.radioComponents = radioComponents;
    }

    getUi(): HTMLDivElement {
        this.radioComponents.forEach(x => x.writeValue(this.currentLineStyle));
        this.radioGroup.style.display = 'flex';
        return this.radioGroup;
    }
}
